import { currencies, currencyNames, defaultCurrency } from '~/config/constant'
import { DEFAULT_FORMAT_PRICE } from '~/constants/currency'
import { store } from '~/redux/store'

// Hàm kiểm tra format giá có thuộc integer hay không
const checkFormatInteger = (priceFormat) => {
  return priceFormat === DEFAULT_FORMAT_PRICE
}

// Hàm xử lý lấy ra options format giá theo dạng integer hoặc dạng decimal
const getOptionsFormatPrice = (isIntegerFormat) => {
  let degitNumber = 2 // Đối với kiểu decimal tối thiểu, tối đa là 2

  if (isIntegerFormat) degitNumber = 0 // Đối với kiểu integer tối thiểu, tối đa là 0

  return {
    minimumFractionDigits: degitNumber, // Tối thiểu ... số thập phân
    maximumFractionDigits: degitNumber, // Tối đa ... số thập phân
  }
}

// Hàm xử lý convert giá theo nhiều đơn vị tiền tệ
export const convertPrice = (amount) => {
  if (typeof amount !== 'number') return ''

  const { currency: currencyName, price_format } = store.getState().restaurant.data
  const currencyObject = currencies.find((item) => item.name === currencyName)

  const integer = checkFormatInteger(price_format)
  const options = getOptionsFormatPrice(integer)

  switch (currencyObject.name) {
    case currencyNames.VND:
      return `${amount.toLocaleString('vi-VI', options)} ${currencyObject.value}`

    case currencyNames.THB:
      return `${amount.toLocaleString('th-TH', options)} ${currencyObject.value}`

    case currencyNames.JPY:
      return `${currencyObject.value}${amount.toLocaleString('ja-JP', options)}`

    default:
      break
  }
  return `${amount.toLocaleString('vi-VI', options)} ${defaultCurrency}`
}

// Hàm xử lý format giá mà ko có tiền tệ
export const convertPriceWithoutCurrency = (amount) => {
  if (typeof amount !== 'number') return ''

  const { currency: currencyName, price_format } = store.getState().restaurant.data
  const currencyObject = currencies.find((item) => item.name === currencyName)

  const integer = checkFormatInteger(price_format)
  const options = getOptionsFormatPrice(integer)

  return `${amount.toLocaleString(currencyObject?.localeString || 'vi-VI', options)}`
}
